/**
 * Initializes input element with value
 * @param {HTMLInputElement | HTMLSelectElement} input
 * @param {string} value
 * @returns {HTMLInputElement | HTMLSelectElement}
 */
export function updateInput(input, value) {
  input.value = value
  return input
}
